module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.page', {
            url: '/page/:scheduleKey',
            data: {
                analytics: 'bws:web:page'
            },
            views: {
                'left-panel@': {
                    controller: [
                        'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                            $scope.showLeftPanel = function () {
                                return breakpointsService.isInSmallFormat;
                            };
                        }
                    ],
                    template: '<div ng-if="showLeftPanel()" style="height: 100%;" wow-hide-scroll wow-scrollbar>' +
                        '<oly-dynamic-content class="dynamic-content2-panelTop" oly-dc-url-schedule></oly-dynamic-content>' +
                        '<oly-dynamic-content class="dynamic-content2-panelBottom" oly-dc-url-schedule="bottom"></oly-dynamic-content>' +
                        '</div>'
                }
            }
        })
        .state('shop.embedded', {
            // this state is used for dynamic content pages which are embedded as iframes
            // in woolworths mobile applications
            url: '/embedded/:scheduleKey',
            data: {
                analytics: `bws:web:embedded`
            },
            views: {
                '@': {
                    template: '<div style="height: 100%;" wow-hide-scroll wow-scrollbar><oly-dynamic-content oly-dc-url-schedule></oly-dynamic-content></div>'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/page.js
 **/